module.exports = __webpack_public_path__ + "static/Terry-Giles-Marina-800x500-ecb9cb31f7a22aca289c60fe8e355a2a.jpg";